export default "__VITE_ASSET__TD2wMgzN__"